import BaseService from "@/js/core/BaseService";
import { BlokEndpoints } from "@/js/modules/bloks/services/BlokEndpoints";

export default class BlokCompanyService extends BaseService {
  async fetchBloksByCompany(companyId) {
    return this.api().get(BlokEndpoints.FetchBloksByCompany.replace(':id', companyId));
  }
}
